<template>
  <div class="container main-content">
    <div class="row">
      <div class="agenda-info col-lg-3">
        <div class="block">
          <span class="block-title">Time</span>
          <span class="block-value" :inner-html.prop="agenda.startDate | agendaDate2(agenda.endDate, agenda.timezone, agenda.hideTime)">
          </span>
          <span class="block-info">Event time has been adjusted to reflect your current time zone.</span>
        </div>
        <div class="block">
          <span class="block-title">Target Audience</span>
          <span class="block-value">{{agenda.targetAudience}}</span>
        </div>
        <div class="block">
          <span class="block-title">Type</span>
          <span class="block-value">{{type.value}}</span>
        </div>
        <div class="block">
          <span class="block-title">Location</span>
          <span class="block-value">-</span>
        </div>
      </div>
      <div class="col-lg-9 article-content">
        <div class="agenda-section">
          <div class="label">Details</div>
          <div v-html="openLinksInNewTab(agenda.subject)"></div>
        </div>

        <div class="agenda-section" v-if="agenda.email">
          <div class="label">Contact</div>
          <div class="row boxes-row">
            <div class="col-lg-4" v-for="member in agenda._embedded.TeamMembers" :key="member.idTeamMember">
              <TeamMemberBox :box="member" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {openLinksInNewTab} from "@/helpers/openLinksInNewTab"
import settings from "@/settings";
import TeamMemberBox from "@/components/persons/TeamMemberBox";
export default {
  name: "AgendaSingleMain",
  components: {TeamMemberBox},
  computed: {
    agenda() {
      return this.$store.getters.agendaEvent
    },
    type() {
      return this.$store.getters.settingsCompanyBySettingTypeCodeAndID(settings.SETTING_TYPES.AGENDA_TYPE, this.agenda.idType)
    }
  },
  methods: {
    openLinksInNewTab: openLinksInNewTab,
  },
}
</script>
